'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002445 from "./presto.-Two-Factor-Auth-View$$anon$45.js";
import * as $j_presto$002etypes$0024$0024anon$00244 from "./presto.types$$anon$4.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dId$0024 from "./presto.types$-Credential-Id$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024 from "./presto.types$-Credential-Username$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$44() {
  this.bD8 = null;
  this.bD0 = null;
  this.bD1 = false;
  this.bD9 = null;
  this.bDa = false;
  this.bDd = null;
  this.bD6 = null;
  this.bD7 = false;
  this.bD2 = null;
  this.bD3 = false;
  this.bD4 = null;
  this.bD5 = false;
  this.bDb = false;
  this.bDc = false;
  this.bD8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bDd = "Credential";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$44 as $c_Lpresto_TwoFactorAuthView$$anon$44 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$44;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$44() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$44 as $h_Lpresto_TwoFactorAuthView$$anon$44 };
$h_Lpresto_TwoFactorAuthView$$anon$44.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bD8;
});
$p.M = (function() {
  if ((!this.bD1)) {
    this.bD0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bD1 = true;
  }
  return this.bD0;
});
$p.O = (function() {
  if ((!this.bDa)) {
    this.bD9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bDa = true;
  }
  return this.bD9;
});
$p.E = (function() {
  return this.bDd;
});
$p.t = (function() {
  if ((!this.bD7)) {
    this.bD6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("username", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("inherited", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bD7 = true;
  }
  return this.bD6;
});
$p.N = (function() {
  if ((!this.bD3)) {
    this.bD2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dId$0024.$m_Lpresto_types$CredentialId$().gG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().cA(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().gl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dUsername$0024.$m_Lpresto_types$CredentialUsername$().gH(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().ep(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bD3 = true;
  }
  return this.bD2;
});
$p.Q = (function() {
  if ((!this.bD5)) {
    this.bD4 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002445.$c_Lpresto_TwoFactorAuthView$$anon$45();
    this.bD5 = true;
  }
  return this.bD4;
});
$p.v = (function() {
  if ((!this.bDc)) {
    this.bDb = false;
    this.bDc = true;
  }
  return this.bDb;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee439) => ((p) => \u03b4scrutinee439.gj(p)))($j_presto$002etypes$0024$0024anon$00244.$m_Lpresto_types$Credential$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$44, "presto.TwoFactorAuthView$$anon$44", ({
  T3: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$44 as $d_Lpresto_TwoFactorAuthView$$anon$44 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$44.js.map
